module.exports = __webpack_public_path__ + "static/media/groupProject.8a0a4719.jpg";